import Axios from "../config/Axios";

// Obtener todos los usuarios de navidad
export const ApiGetAllUsuariosNavidad = async (params = {}) => {
  try {
    const result = await Axios.get(`/GETallUsuariosNavidad`, { params });
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Obtener total de usuarios de navidad
export const ApiGetTotalUsuariosNavidad = async (params = {}) => {
  try {
    const result = await Axios.get(`/GETotalAllUsuariosNavidad`, { params });
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Crear usuario de navidad
export const ApiCreateUsuarioNavidad = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreateUsuarioNavidad`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Actualizar usuario de navidad
export const ApiUpdateUsuarioNavidad = async (data) => {
  try {
    const result = await Axios.post(`/POSTeditUsuarioNavidad`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Eliminar usuario de navidad
export const ApiDeleteUsuarioNavidad = async (data) => {
  try {
    const result = await Axios.post(`/POSTdeleteUsuarioNavidad`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Buscar usuarios de navidad
export const ApiBuscarUsuariosNavidad = async (query) => {
  try {
    const result = await Axios.get(`/GETbuscarUsuariosNavidad`, {
      params: { query }
    });
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Procesar Excel de usuarios navidad
export const ApiProcessExcelNavidad = async (formData) => {
  try {
    const result = await Axios.post(`/POSTprocessExcelUsuariosNavidad`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Obtener todas las canastas
export const ApiGetAllCanastas = async (params = {}) => {
  try {
    const result = await Axios.get(`/GETallCanastas`, { params });
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Crear canasta navideña
export const ApiCreateCanasta = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreateCanasta`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Actualizar estado de canasta
export const ApiUpdateEstadoCanasta = async (data) => {
  try {
    const result = await Axios.post(`/POSTupdateEstadoCanasta`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Eliminar canasta
export const ApiDeleteCanasta = async (data) => {
  try {
    const result = await Axios.post(`/POSTdeleteCanasta`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Entregar canasta
export const ApiEntregarCanasta = async (data) => {
  try {
    const result = await Axios.post(`/POSTentregarCanasta`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Crear configuración
export const ApiCreateConfiguracion = async (data) => {
  try {
    const result = await Axios.post(`/POSTcreateConfiguracion`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Obtener todas las configuraciones
export const ApiGetAllConfiguraciones = async () => {
  try {
    const result = await Axios.get(`/GETallConfiguraciones`);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Actualizar configuración
export const ApiUpdateConfiguracion = async (data) => {
  try {
    const result = await Axios.post(`/POSTupdateConfiguracion`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};

// Eliminar configuración
export const ApiDeleteConfiguracion = async (data) => {
  try {
    const result = await Axios.post(`/POSTdeleteConfiguracion`, data);
    return result.data;
  } catch (e) {
    return {
      sms: "err",
      data: [],
      mensaje: e,
    };
  }
};
